import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Leads do Grupo", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "pt-3 pb-2 mb-2 border-bottom" }, null, -1)
const _hoisted_6 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "container-fluid" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "table-responsive mb-4" }
const _hoisted_11 = { class: "table table-striped table-sm" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Ações "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " id "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Nome"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Email"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Whatsapp ")
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "btn-group mr-2" })
], -1)
const _hoisted_14 = {
  key: 0,
  class: "d-flex justify-content-center mt-4 mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fechar && _ctx.fechar(...args)))
          })
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("input", {
            class: "form-control",
            placeholder: "Procurar Nome ou Descrição",
            onKeyup: _cache[1] || (_cache[1] = ($event: any) => ($setup.search($event.target.value)))
          }, null, 32)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("table", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredTable, (l) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: l.lead_id
                      }, [
                        _hoisted_13,
                        _createElementVNode("td", null, _toDisplayString(l.lead_id), 1),
                        _createElementVNode("td", null, _toDisplayString(l.lead.name), 1),
                        _createElementVNode("td", null, _toDisplayString(l.lead.email), 1),
                        _createElementVNode("td", null, _toDisplayString(l.lead.whatsapp), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              ($setup.page < $setup.lastPage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-secondary",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.loadMore && $setup.loadMore(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}